export class JobShareDetails {
    shortenedUrl: string;
    emailUrl: string;
    jobName: string;
    facebookUrl: string;
    linkedInUrl: string;
    twitterUrl: string;
}
